import React, { useEffect } from "react";

import { connect } from "react-redux";

import get from "lodash/get";
import indexOf from "lodash/indexOf";

import Grid from "@material-ui/core/Grid";
import { withStyles } from "@material-ui/core/styles";

import Copyright from "../../../../components/Copyright";
import Markdown from "../shared/md";
import PageImage from "../shared/PageImage/index";
import { getPageContent } from "../shared/selectors";
import { OUTRO_PAGE } from "../types";
import { gaPageView } from "../../../../utils/analytics";

const styles = theme => ({
  container: {
    padding: "200px 80px 80px 80px",
    [theme.breakpoints.down("xs")]: {
      padding: "80px 24px 24px 24px"
    }
  },
  contentWrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  image: {
    [theme.breakpoints.up("xl")]: {
      justifyContent: "center"
    }
  },
  content: {
    maxWidth: 450
  }
});

const panelists = ["borderless", "branded", "catalyst_mr", "cint", "dataspring", "empanel", "forsker", "globalsurvey", "gmo_research", "luthresearch", "symmetric", "torfac"];

const getUrl = (survey, member_id, ext_uuid, completed) => {
  if (member_id === "borderless") {
    const url =
      completed
        ? `https://surveys.thepanelstation.com/crdct.aspx?route=${ext_uuid}A28D49B168410E78`
        : `https://surveys.thepanelstation.com/crdct.aspx?route=${ext_uuid}2E32549167C36C23`;

    return url;
  }

  if (member_id === "branded") {
    const url =
      completed
        ? `https://r.mintvine.com/success/?uid=${ext_uuid}`
        : `https://r.mintvine.com/nq/?uid=${ext_uuid}`;

    return url;
  }

  if (member_id === "catalyst_mr") {
    const url =
      completed
        ? `https://www.cmrpanel.com/surveys/lp.php?CMRS=10&CMRID=${ext_uuid}`
        : `https://www.cmrpanel.com/surveys/lp.php?CMRS=20&CMRID=${ext_uuid}`;

    return url;
  }

  if (member_id === "cint") {
    const url =
      completed
        ? `https://s.cint.com/Survey/Complete?ProjectToken=ee1503ae-f359-434a-a602-e240e4b53456`
        : `https://s.cint.com/Survey/EarlyScreenOut?ProjectToken=cbe8b25f-8a79-f85c-4672-b9f2cb57039a`;

    return url;
  }

  if (survey === "sndp1" && member_id === "dataspring") {
    const url =
      completed
        ? `https://d8aspring.post-survey.com/ans/back/?key=FnZt7soK&status=comp`
        : `https://d8aspring.post-survey.com/ans/back/?key=FnZt7soK&status=scrout`;

    return url;
  }

  if (member_id === "dataspring") {
    const url =
      completed
        ? `https://d8aspring.post-survey.com/ans/back/?key=e1JKN18k&status=comp`
        : `https://d8aspring.post-survey.com/ans/back/?key=e1JKN18k&status=scrout`;

    return url;
  }

  if (member_id === "empanel") {
    const url =
      completed
        ? `https://bizpinion.com/endlink2.php?t=n&sr=ZxExP1AdNu2yJ8bd6&id=${ext_uuid}`
        : `https://bizpinion.com/endlink2.php?t=n&sr=ZxExP10S88tVjU3e6&id=${ext_uuid}`;

    return url;
  }

  if (member_id === "forsker") {
    const url =
      completed
        ? `https://forskerpartners.com/simpleProcess.php?status=1&pid=${ext_uuid}`
        : `https://forskerpartners.com/simpleProcess.php?status=2&pid=${ext_uuid}`;

    return url;
  }

  if (member_id === "globalsurvey") {
    const url =
      completed
        ? `https://www.gowebsurveys.com/surveyProcess.php?authToken=36e19e554b0859e5a3979d185125f3a6&pid=${ext_uuid}`
        : `https://www.gowebsurveys.com/surveyProcess.php?authToken=2063fd0cd56d761221b5391fcde27891&pid=${ext_uuid}`;

    return url;
  }

  if (member_id === "gmo_research") {
    const url =
      completed
        ? `https://infopanel.jp/lpark/enqInfoUpdateForNC.do?status=1&id=${ext_uuid}`
        : `https://infopanel.jp/lpark/enqInfoUpdateForNC.do?status=2&id=${ext_uuid}`;

    return url;
  }

  if (member_id === "luthresearch") {
    const url =
      completed
        ? `https://pt.surveysavvy.com/survey/finish/8843/5`
        : `https://pt.surveysavvy.com/survey/finish/8843/4`;

    return url;
  }

  if (member_id === "symmetric") {
    const url =
      completed
        ? `https://www.daisurvey.com/surveyV3/RenderSurvey.aspx?SurveyID=gsuguhKlGRzTRU5yq%2fMMxA%3d%3d&PayCode=1&ID=${ext_uuid}`
        : `https://www.daisurvey.com/surveyV3/RenderSurvey.aspx?SurveyID=gsuguhKlGRzTRU5yq%2fMMxA%3d%3d&PayCode=2&ID=${ext_uuid}`;

    return url;
  }

  if (survey === "sndp1" && member_id === "torfac") {
    const url =
      completed
        ? `https://pollrouting.com/router/ViTo2713ed11bafd9b8f237f6e5b1ade73e57c0/passback.php?sd=s&st=9C9QagwfFBhk&wspid=${ext_uuid}`
        : `https://samplicity.wisesample.com/return/curlhandler.php?token=6d76e7ebbcb8ade97921f9ec17eb9246&e=r&wspid=${ext_uuid}`;

    return url;
  }

  if (member_id === "torfac") {
    const url =
      completed
        ? `https://pollrouting.com/router/ViTo2713ed11bafd9b8f237f6e5b1ade73e57c0/passback.php?sd=s&st=9C9QagwfFBhk&wspid=${ext_uuid}`
        : `https://samplicity.wisesample.com/return/curlhandler.php?token=6d76e7ebbcb8ade97921f9ec17eb9246&e=r&wspid=${ext_uuid}`;

    return url;
  }

  return "";
};

const OutroPage = ({ classes, content, Images, survey, member_id, ext_uuid, completed }) => {
  useEffect(() => {
    gaPageView();
  }, []);

  const isPanelist = indexOf(panelists, member_id) !== -1;

  if (isPanelist) {
    const url = getUrl(survey, member_id, ext_uuid, completed);

    const panelistContent = `##### Thank you for your response. \n\n\n Click below to go to your panel \n\n\n\n[Click Me](${url} "button")`;
    return (
      <Grid container spacing={16} className={classes.container}>
        <Grid item xs={12} className={classes.contentWrapper}>
          <Markdown content={panelistContent} className={classes.content} />
        </Grid>
        <Grid item xs={12}>
          <Copyright />
        </Grid>
      </Grid>
    );
  }

  const { OutroAsset } = Images;

  return (
    <Grid container spacing={16} className={classes.container}>
      <Grid item xs={12} className={classes.contentWrapper}>
        <PageImage
          asset={OutroAsset}
          alt="outro-img"
          className={classes.image}
        />
        <Markdown content={content} className={classes.content} />
      </Grid>
      <Grid item xs={12}>
        <Copyright />
      </Grid>
    </Grid>
  );
};

const hasReachedComplete = (state, questionId) => {
  return get(state, ["payload", "answer", questionId, "duration"], null) === 0;
}

const mapStateToProps = state => ({
  content: getPageContent(state, OUTRO_PAGE),
  survey: get(state, ["survey", "name"]),
  member_id: get(state, ["meta", "member_id"], ""),
  ext_uuid: get(state, ["meta", "ext_uuid"], ""),
  questionId: get(
    state,
    ["cursor", "path", get(state, ["cursor", "index"])],
    ""
  ),
  completed: hasReachedComplete(state, "MRK_REF1")
    || hasReachedComplete(state, "MRK_REF2")
    || hasReachedComplete(state, "END_QLF1")
    || hasReachedComplete(state, "END_QLF2")
    || hasReachedComplete(state, "END_QLF1_FWD")
    || hasReachedComplete(state, "END_QLF2_FWD")
});

export default connect(mapStateToProps)(withStyles(styles)(OutroPage));
